import { TreeSelect } from "@evg-ui/lib/components/TreeSelect";
import Dropdown from "components/Dropdown";
import { noFilterMessage } from "constants/strings";
import { useTaskStatuses } from "hooks";
import styles from "./index.module.css";

interface Props {
  versionId: string;
  selectedStatuses: string[];
  selectedBaseStatuses: string[];
  onChangeStatusFilter: (s: string[]) => void;
  onChangeBaseStatusFilter: (s: string[]) => void;
}

export const TaskStatusFilters: React.FC<Props> = ({
  onChangeBaseStatusFilter,
  onChangeStatusFilter,
  selectedBaseStatuses,
  selectedStatuses,
  versionId,
}) => {
  const { baseStatuses, currentStatuses } = useTaskStatuses({ versionId });

  return (
    <div className={styles.container}>
      <div className={styles.selectorWrapper}>
        <Dropdown
          buttonText={`Task Status: ${
            selectedStatuses.length
              ? selectedStatuses.join(", ")
              : noFilterMessage
          }`}
          data-testid="task-status-filter"
        >
          <TreeSelect
            onChange={onChangeStatusFilter}
            state={selectedStatuses}
            tData={currentStatuses}
          />
        </Dropdown>
      </div>
      <div className={styles.selectorWrapper}>
        <Dropdown
          buttonText={`Base Task Status: ${
            selectedBaseStatuses.length
              ? selectedBaseStatuses.join(", ")
              : noFilterMessage
          }`}
          data-testid="base-task-status-filter"
        >
          <TreeSelect
            onChange={onChangeBaseStatusFilter}
            state={selectedBaseStatuses}
            tData={baseStatuses}
          />
        </Dropdown>
      </div>
    </div>
  );
};
